import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { RefreshSlackChannels } from 'domain/usecases/slack/refresh-slack-channels';
import { RemoteRefreshSlackChannels } from 'data/usecases/slack/remote-refresh-slack-channels';

export const makeRefreshSlackChannels = (): RefreshSlackChannels => {
  return new RemoteRefreshSlackChannels(makeApiUrl('/slack/channels/refresh'), makeAuthorizeHttpClientDecorator());
};
